<script>

  import ArticlesList from '@/components/ArticlesList'
  import FetchArticles from '@/middleware/fetch-articles'

  export default {
    components: {
      ArticlesList
    },
    middleware: [FetchArticles],
    scrollToTop: true
  }
</script>

<template>
  <articles-list />
</template>
